export default {"src":"/_next/static/media/highlights-icon-4.2e7fca5a.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};